import { useLocation } from 'react-router-dom';
import { DEFAULT_USE_CASE, USE_CASE_PATHS, UseCase, useCases } from '../config/useCasesConfig';
import { unprefixedPath } from './localizedPath';

const useCaseOfPath = (pathname: string): UseCase | undefined => {
  const path = unprefixedPath(pathname);
  return useCases.find((useCase) => USE_CASE_PATHS[useCase] === path);
};

/** Whether the path shows the home page, plain or as one of its use case variants. */
export const isHomePath = (pathname: string): boolean => unprefixedPath(pathname) === '/' || useCaseOfPath(pathname) !== undefined;

/** The use case picked in the URL ('/en/testing'), the default one on the plain home page. */
export const useUseCase = (): UseCase => useCaseOfPath(useLocation().pathname) ?? DEFAULT_USE_CASE;
